import { createElement } from "react";
/**
 * External dependencies
 */
import { SVG } from '@wordpress/primitives';
export default createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, createElement("polygon", {
  fill: "#394fa1",
  points: "21.5 14.7 7.2 6.5 7.2 6.5 12 3.7 19.2 7.9 19.2 10.6 21.5 12 21.5 6.5 12 1 2.5 6.5 19.1 16.1 16.7 17.5 2.5 9.3 2.5 12 16.8 20.2 21.5 17.5 21.5 14.7"
}), createElement("polygon", {
  fill: "#3cb44a",
  points: "2.5 14.8 2.5 17.5 12 23 14.4 21.6 2.5 14.8"
}));